export const getToday = () => new Date()
export const getCurrentYear = () => {
	return new Date().getFullYear()
}

export const formattedDate = (date) => {
	const parseYear = date.getFullYear(),
		parseMonth = date.getMonth() + 1,
		parseDay = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

	return parseYear + '-' + parseMonth + '-' + parseDay
}

/**
 * 날짜 문자열을 YYYY-MM-DD 형식으로 변환
 * @param {string|Date} dateInput - 날짜 문자열 또는 Date 객체
 * @returns {string} YYYY-MM-DD 형식의 날짜 문자열
 */
export const formatDateToYYYYMMDD = (dateInput) => {
	if (!dateInput) return ''

	const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput

	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')

	return `${year}-${month}-${day}`
}

export const rangeYears = () => {
	const currentYear = getCurrentYear()
	const result = []

	for (let i = currentYear; i > currentYear - 51; --i) {
		result.push(i)
	}

	return result
}

/**
 * 두 날짜 범위가 겹치는지 확인하는 유틸리티 함수
 * @param {string} start1 - 첫 번째 범위 시작 날짜
 * @param {string} end1 - 첫 번째 범위 종료 날짜
 * @param {string} start2 - 두 번째 범위 시작 날짜
 * @param {string} end2 - 두 번째 범위 종료 날짜
 * @returns {boolean} 겹치면 true, 아니면 false
 */
export const areDatesOverlapping = (start1, end1, start2, end2) => {
	const d1_start = new Date(start1)
	const d1_end = new Date(end1)
	const d2_start = new Date(start2)
	const d2_end = new Date(end2)

	return !(d1_end < d2_start || d1_start > d2_end)
}

/**
 * 오늘 날짜를 YYYY-MM-DD 형식으로 반환
 * @returns {string} YYYY-MM-DD 형식의 오늘 날짜
 */
export const getTodayDateString = () => {
	const today = new Date()
	const year = today.getFullYear()
	const month = (today.getMonth() + 1).toString().padStart(2, '0')
	const day = today.getDate().toString().padStart(2, '0')
	return `${year}-${month}-${day}`
}

/**
 * Date 객체를 투어 날짜 형식으로 변환 (YYYY-MM-DD~)
 * @param {Date} dateObject - 변환할 Date 객체
 * @returns {string|null} (YYYY-MM-DD~) 형식의 문자열 또는 null
 */
export const getTourDateString = (dateObject) => {
	if (!dateObject || !(dateObject instanceof Date)) {
		return null
	}
	const year = dateObject.getFullYear()
	const month = (dateObject.getMonth() + 1).toString().padStart(2, '0')
	const day = dateObject.getDate().toString().padStart(2, '0')
	if (isNaN(year) || isNaN(month) || isNaN(day)) {
		return null
	}
	return `(${year}-${month}-${day}~)`
}

export const getYYYYMMString = (dateString) => {
	if (!dateString) return ''
	// YYYY-MM-DD 형식에서 YYYY를 YY로 변환 (앞 두 글자 제거)
	return dateString.replace(/^\d{2}(\d{2}-)/, '$1')
}

/**
 * 날짜 문자열을 YYYY.MM.DD 형식으로 변환 (점으로 구분)
 * @param {string|Date} dateString - 날짜 문자열 또는 Date 객체
 * @returns {string} YYYY.MM.DD 형식의 날짜 문자열 또는 '-'
 */
export const formatDateDot = (dateString) => {
	if (!dateString) return '-'
	const date = new Date(dateString)
	const yyyy = date.getFullYear()
	const mm = String(date.getMonth() + 1).padStart(2, '0')
	const dd = String(date.getDate()).padStart(2, '0')
	return `${yyyy}.${mm}.${dd}`
}

/**
 * 날짜 문자열에서 시간을 HH:MM 형식으로 추출
 * @param {string|Date} dateString - 날짜 문자열 또는 Date 객체
 * @returns {string} HH:MM 형식의 시간 문자열
 */
export const formatTimeHHMM = (dateString) => {
	if (!dateString) return ''
	const date = new Date(dateString)
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')
	return `${hours}:${minutes}`
}

/**
 * 날짜 문자열을 YYYY-MM-DD HH:MM 형식으로 변환
 * @param {string|Date} dateInput - 날짜 문자열 또는 Date 객체
 * @returns {string} YYYY-MM-DD HH:MM 형식의 날짜 문자열
 */
export const formatDateTimeToYYYYMMDDHHMM = (dateInput) => {
	if (!dateInput) return ''

	const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput

	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')
	const hours = String(date.getHours()).padStart(2, '0')
	const minutes = String(date.getMinutes()).padStart(2, '0')

	return `${year}-${month}-${day} ${hours}:${minutes}`
}
